import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LAB_PREVIEW_ID,
  labPreviewStages,
  useLabPreview,
  type LabPreviewStage,
} from "./labPreview";

export function LabPreviewControls() {
  const preview = useLabPreview();
  const location = useLocation();
  const navigate = useNavigate();
  function changeStage(stage: LabPreviewStage) {
    preview.setStage(stage);
    if ((stage === "actual" || stage === "empty") && location.pathname.endsWith(`/${LAB_PREVIEW_ID}`)) navigate("/app/labs");
  }
  if (!preview.available) return null;
  return (
    <aside
      className="border border-line-subtle bg-sunken p-12 my-12 text-ink"
      aria-label="Staging Labs preview"
    >
      <div className="flex flex-wrap items-center justify-between gap-10">
        <label className="type-label-xs flex items-center gap-10">
          Staging preview
          <select
            aria-label="Preview blood test stage"
            value={preview.stage}
            onChange={(event) =>
              changeStage(event.target.value as LabPreviewStage)
            }
            className="type-body-sm border border-line-subtle bg-page min-h-44 px-8"
          >
            {labPreviewStages.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>
        {preview.stage !== "actual" && (
          <button
            className="text-14 underline min-h-44"
            onClick={() => changeStage("actual")}
          >
            Exit preview
          </button>
        )}
      </div>
      {preview.stage !== "actual" && (
        <p role="status" className="type-body-sm text-ink-secondary mt-8">
          Example data only. No orders, payments or reports are changed.{" "}
          {preview.stage !== "empty" && (
            <Link className="underline" to={`/app/labs/${LAB_PREVIEW_ID}`}>
              Open preview test
            </Link>
          )}
        </p>
      )}
    </aside>
  );
}
